var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'nav-open': _vm.$showSidebar}},[_c('notifications',{attrs:{"position":"top center","width":"400"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }